import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../service/api';
import { API_ROUTES } from '../constants/constant';
import authService from '../service/authService';

const RoleSelector = () => {
  const navigate = useNavigate();
  const [assignments, setAssignments] = useState([]);

  useEffect(() => {
    const email = authService.getInstituteEmailID();

    if (authService.isSuperAdmin()) {
      (async () => {
        try {
          const userResponse = await api.post(API_ROUTES.GETUSERIDBYEMAIL, {
            InstituteEmailID: email
          });
          const userId = userResponse.data.userId;

          authService.setActiveRole({
            role: 'SuperAdmin',
            userId: { _id: userId, username: email }
          });

          navigate('/home/');
        } catch (err) {
          console.error('Failed to fetch userId for SuperAdmin:', err);
        }
      })();
    } else {
      fetchUserAssignments();
    }
  }, []);

  const fetchUserAssignments = async () => {
    const email = authService.getInstituteEmailID();
    if (!email) return;

    try {
      const userResponse = await api.post(API_ROUTES.GETUSERIDBYEMAIL, {
        InstituteEmailID: email
      });

      const userId = userResponse.data.userId;

      const assignmentRes = await api.post(API_ROUTES.GETUSERASSIGNMENTSBYUSERID, {
        userId,
        InstituteEmailID: email,
        targetUserId: userId
      });

      setAssignments(assignmentRes.data.assignments || []);
    } catch (err) {
      console.error('Error fetching assignments by email:', err);
    }
  };

  const handleSelectRole = (assignment) => {
    authService.setActiveRole(assignment);
    navigate('/home/');
  };

  const handleLogout = () => {
    authService.logout(navigate);
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center mt-3">
        <h2>Select Role to Continue</h2>
        <button className="btn btn-outline-danger btn-sm" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="table-responsive mt-4">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Organization</th>
              <th>Department</th>
              <th>Role</th>
              <th>SubDepartments</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {assignments?.length > 0 ? (
              assignments.map((assign, idx) => (
                <tr key={idx}>
                  <td>{assign.instituteId?.InstituteName || '-'}</td>
                  <td>{assign.departmentId?.name || '-'}</td>
                  <td>{assign.role}</td>
                  <td>
                    {assign.subDepartments?.length > 0
                      ? assign.subDepartments.map(sub => sub.subDepartmentId?.SubDepartmentName || '-').join(', ')
                      : '-'}
                  </td>
                  <td>
                    {assign.isFullyApproved ? (
                      <span className="badge bg-success">Approved</span>
                    ) : (
                      <span className="badge bg-warning text-dark">Pending</span>
                    )}
                  </td>
                  <td>
                    {assign.isFullyApproved ? (
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => handleSelectRole(assign)}
                      >
                        Select
                      </button>
                    ) : (
                      <span className="text-muted">Awaiting Approval</span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">No role assigned</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RoleSelector;
